import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import axios from "axios";

import SideMenu from "./component/common/component/sideMenu";
import Header from "./component/common/component/header";
import ProjectDetailView from "./component/projectDetailPage/projectDetailView";

import { ProjectDetailContainer, ProjectSection } from "./component/common/styled/project";
import TooltipSideMenu from "../../../common/tooltipSideMenu";

const ProjectDetailPage = () => {
  const { projectNo } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const [project, setProject] = useState();
  const [projectNotice, setProjecNotice] = useState();
  const [participantList, setParticipantList] = useState([]);
  const [projectRoomList, setProjectRoomList] = useState([]);
  const [participant, setParticipant] = useState();
  const [events, setEvents] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [projectInfo, setProjectInfo] = useState({});
  const [active, setActive] = useState(0);
  const [openMenu, setOpenMenu] = useState(false);
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [clickSideMenu, setClickSideMenu] = useState(false);

  useEffect(() => {
    getProject();

    const tabValue = location?.state?.tab;
    if (tabValue !== undefined) {
      setActive(tabValue || 0);

      const { tab, ...rest } = location.state || {};
      navigate(location.pathname, { replace: true, state: { ...rest } });
    }
  }, [projectNo]);

  // 프로젝트 조회
  const getProject = async () => {
    const url = "/api/projectList";
    const body = {
      projectNo,
      mberNo: user.mberNo,
      delYn: "N",
    };

    const res = await axios.post(url, body);

    if (res.status === 200) {
      const allProjects = [].concat(
        res.data.cmpnyProjectList || [],
        res.data.fixedProjectList || [],
        res.data.groupProjectList || [],
        res.data.otherProjectList || [],
      );

      const data = allProjects.filter((item) => item.projectNo === parseInt(projectNo))?.[0];

      if (data) {
        setProject(data);
        await getProjectNotiList(data.projectNo);
        await getParticipantList(data);

        setProjectInfo((info) => ({
          ...info,
          projectNo: data.projectNo,
          orgNo: data.orgNo,
          gbn: data.gbn,
          mberNo: data.mberNo,
          projectNm: data.projectNm,
          projectDesc: data.projectDesc,
          publicYn: data.publicYn,
          completeYn: data.completeYn,
          updateMberId: user.userName,
        }));
      } else {
        setProject(null);
        toast.error("해당 프로젝트가 존재하지 않거나 삭제되었습니다.", { toastId: "no-access" });
        navigate("/mypage/projectList");
      }
    }
  };

  // 일정 조회
  const getProjectSchedule = async (project = null, mber = user) => {
    const scheduleData = await getSchedule(project, mber, true); // 필터링
    let eventsData = await getSchedule(project); // 전체

    const scheduleIds = scheduleData.map((item) => item.scheduleNo);

    eventsData = eventsData.map((item) => {
      if (!scheduleIds.includes(item.scheduleNo)) {
        return { ...item, disabled: true };
      }
      return item;
    });

    setSchedule(scheduleData);
    setEvents(eventsData);
  };

  // 데이터 조회
  const getSchedule = async (projectParam = project, mberParam = user, flag = false) => {
    const url = "/api/scheduleList";
    const body = { projectNo };

    if (flag) {
      body.mberNo = user.mberNo;

      if (projectParam.gbn === "C") {
        if (mberParam) {
          body.cmpnyNos = [mberParam.orgNo];
        } else {
          const target = participantList.find((member) =>
            company.some((cmp) => cmp.cmpnyNo === member.orgNo),
          );
          if (target) body.cmpnyNos = [target.orgNo];
        }
      }
    }

    if (projectParam.gbn === "G") {
      body.groupNos = [projectParam.orgNo];
    }

    const res = await axios.post(url, body);
    if (res.status === 200) {
      return res.data;
    } else {
      throw new Error("스케줄 조회 실패");
    }
  };

  // 공지 조회
  const getProjectNotiList = async (projectNo) => {
    const url = "/api/notiList";
    const body = { projectNo };

    const res = await axios.post(url, body);

    if (res.status === 200) {
      setProjecNotice(res.data.rtnModel);
      const notice = res.data.rtnModel;
      setProjectInfo((info) => ({
        ...info,
        title: notice.title,
        content: notice.content,
        fileList: notice.fileList,
      }));
    }
  };

  // 프로젝트 룸 조회
  const getProjectRoom = async (data, mbers) => {
    let orgNos = [];

    if (data.gbn === "G") {
      orgNos = [data.orgNo];
    } else {
      const target = company.find((cmpny) => cmpny.cmpnyNo === data.orgNo);

      // 프로젝트 생성 회사와 일치할 경우
      if (target) {
        orgNos = [target.cmpnyNo];
      } else {
        const matchedMbers = mbers.filter((mber) =>
          company.some((cmpny) => cmpny.cmpnyNo === mber.orgNo),
        );
        orgNos = matchedMbers.map((mber) => mber.orgNo);
      }
    }

    if (orgNos.length === 0) return;

    const url = "/api/roomList";
    const body = {
      projectNo,
      orgNos,
      mberNo: user.mberNo,
      delYn: "N",
    };

    const res = await axios.post(url, body);

    if (res.status === 200) {
      setProjectRoomList(res.data);
    }
  };

  // 프로젝트 참여자 조회
  const getParticipantList = async (data) => {
    const url = "/api/participantList";
    const body = {
      projectNo,
      // delYn: "N",
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: false,
    };

    const res = await axios.post(url, body);

    if (res.status === 200) {
      const memberList = res.data.content;
      const isMember = memberList.find((participant) => participant.mberNo === user.mberNo);
      const hasSameCompany = memberList.some((member) =>
        company.some((item) => item.cmpnyNo === member.orgNo),
      );
      const members = memberList.filter((item) => item.delYn === "N");

      setParticipant(isMember);
      setParticipantList(members);

      const isWithdrawn = isMember?.delYn === "Y";
      if (
        data.gbn === "C" &&
        (!isMember || isWithdrawn) &&
        (!hasSameCompany || data.publicYn === "N")
      ) {
        navigate("/mypage/projectList");
        toast.error("조회 권한이 존재하지 않습니다.", { toastId: "no-access" });
      }

      await getProjectSchedule(data, isMember);
      await getProjectRoom(data, memberList);
    }
  };

  return (
    <ProjectSection>
      <ProjectDetailContainer>
        <Header
          clickSideMenu={clickSideMenu}
          setClickSideMenu={setClickSideMenu}
          navigatePath={"/mypage/projectList"}
        />
        <div className="inner">
          <SideMenu
            showSideMenu={showSideMenu}
            setShowSideMenu={setShowSideMenu}
            setActive={setActive}
          />
          <ProjectDetailView
            project={project}
            setProject={setProject}
            projectNotice={projectNotice}
            participantList={participantList}
            projectInfo={projectInfo}
            getProject={getProject}
            active={active}
            setActive={setActive}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            getParticipantList={getParticipantList}
            participant={participant}
            projectRoomList={projectRoomList}
            getProjectRoom={getProjectRoom}
            setShowSideMenu={setShowSideMenu}
            events={events}
            schedule={schedule}
            getProjectSchedule={getProjectSchedule}
          />
        </div>
        {clickSideMenu && !isMobile && (
          <TooltipSideMenu
            clickSideMenu={clickSideMenu}
            setClickSideMenu={setClickSideMenu}
            isMargin={false}
          />
        )}
      </ProjectDetailContainer>
    </ProjectSection>
  );
};

export default ProjectDetailPage;
